module.exports = __webpack_public_path__ + "static/media/card_connect.b64680e8.png";